<div class="overlay-notification">
  <ng-content></ng-content>
</div>
